
import { Vue, Component } from "vue-property-decorator";
import { ORDER_STATES, PROVIDERS, accountLabel, formatDay, formatMoney, hostingLabel, loadMarketplace } from "@/data/MarketplaceSites";

@Component
export default class MarketplaceClients extends Vue {
  rows: any[] = [];
  expanded: any[] = [];
  loading = false;
  error = "";
  search = "";
  onlyBuyers = false;
  day = formatDay;
  money = formatMoney;

  headers = [
    { text: "Клиент", value: "client" },
    { text: "Телефон", value: "phone" },
    { text: "Зарегистрирован", value: "createDate" },
    { text: "Сайтов", value: "siteCount", align: "end" },
    { text: "Баланс", value: "balance", align: "end" },
    { text: "Оплачено", value: "paid", align: "end" },
    { text: "Последняя оплата", value: "lastPaidAt" },
    { text: "Не оплачено", value: "waiting", sortable: false },
    { text: "", value: "data-table-expand" },
  ];

  breadcrumbs = [
    { text: "Главная", to: "/" },
    { text: "Маркетплейс сайтов", disabled: true },
    { text: "Клиенты и оплаты", disabled: true },
  ];

  get visibleRows() {
    return this.onlyBuyers ? this.rows.filter((r) => r.orders.length || r.sites.length) : this.rows;
  }

  get summary() {
    const buyers = this.rows.filter((r) => r.paid > 0).length;
    const paid = this.rows.reduce((sum, r) => sum + r.paid, 0);
    const test = this.rows.reduce((sum, r) => sum + r.orders.filter((o: any) => o.isTest && o.paidAt).length, 0);
    return [
      { title: "Зарегистрировано", value: this.rows.length },
      { title: "Оплатили хотя бы раз", value: buyers },
      { title: "Оплачено (без тестовых)", value: formatMoney(paid) },
      { title: "Тестовых оплат", value: test },
    ];
  }

  toggle(item: any) {
    this.expanded = this.expanded[0]?.id === item.id ? [] : [item];
  }

  async created() {
    await this.load();
  }

  async load() {
    this.loading = true;
    this.error = "";
    try {
      // Заказы клиента API отдаёт от свежих к старым, суммы и «ждёт оплаты» уже посчитаны
      const data = await loadMarketplace("clients");
      this.rows = data.items.map((c: any) => ({
        ...c,
        client: c.name,
        email: c.email ?? "",
        phone: c.phone ?? "",
        account: accountLabel(c),
        balance: c.balance ?? 0,
        siteCount: c.sites.length,
        lastActivity: c.lastPaidAt || c.orders[0]?.createDate || c.createDate,
        waiting: c.waiting ? `ждёт оплаты: ${c.waiting}` : "",
        sites: c.sites.map((s: any) => ({ ...s, hosting: hostingLabel(s) })),
        orders: c.orders.map((o: any) => ({
          ...o,
          state: ORDER_STATES[o.instanceStateId] ?? { caption: o.paidAt ? "Оплачен" : "—", color: "grey lighten-3" },
          provider: o.provider ? (PROVIDERS[o.provider] ?? o.provider) : "",
        })),
      }));
    } catch (e: any) {
      this.error = e?.response?.data?.message ?? "Не удалось загрузить клиентов";
    } finally {
      this.loading = false;
    }
  }
}
